import { combineReducers } from "redux";
import AuthReducer from "./auth/login/reducer";
import PartnerReducer from "./partner/reducer";
import RewardReducer from "./reward/reducer";
const rootReducer = combineReducers({
  user: AuthReducer,
  partner: PartnerReducer,
  reward: RewardReducer,
});

export default rootReducer;
